module.exports = __webpack_public_path__ + "img/horizontal_2@2x.53ebde5d.png";